export const appropriateKeyPressed = (key, ...args) => args.includes(key);
//# sourceMappingURL=helpers.js.map